// Zod schemas for accounts/OAuth (ticket 302). `SocialUserProfile` used to be
// a hand-duplicated draft of edge-proposal.md's account.ts -- now that
// @proef/contract's real UserProfile has shipped (apps/edge/src/account.ts,
// apps/edge/src/auth.ts's toUserProfile), it is a straight re-export under
// this module's established name rather than a second schema to keep in sync.
import { UserProfile } from "@proef/contract";
import { z } from "zod";

export const SocialUserProfile = UserProfile;
export type SocialUserProfile = UserProfile;

export const OAuthProvider = z.enum(["google", "microsoft", "instagram", "tiktok"]);
export type OAuthProvider = z.infer<typeof OAuthProvider>;

/** `GET /v1/auth/providers`-style gate the PWA reads to grey out a
 * not-yet-reviewed provider row, instead of discovering it only on
 * redirect failure. */
export const OAuthProviderAvailability = z.record(OAuthProvider, z.boolean());
export type OAuthProviderAvailability = z.infer<typeof OAuthProviderAvailability>;

/** `PATCH /v1/account/profile` -- About's `about__public-row` toggle is the
 * only surface that ever sets `isPublic`; not in edge-proposal.md explicitly,
 * assumption mirroring UpdateGroupRequest's PATCH-semantics shape
 * (every field optional). */
export const UpdateProfileRequest = z.object({
  isPublic: z.boolean().optional(),
});
export type UpdateProfileRequest = z.infer<typeof UpdateProfileRequest>;
